/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToRem, pxToEm, mediaQuery, replacePXinStringWithEM } from '@insticator/insticator-ui'; // iui-utils



/* ++++++++++ --------------- EXPORT : COMMENTING CONFIGURATION: COLOR SCHEME SECTION : STYLES --------------- ++++++++++ */
export default theme => ({
  ratingscolorschemesection: {
    marginTop: pxToEm(16),
    marginBottom: pxToEm(16),
    '& .sectiondescription' : {
      '& .colorspreview': {
        height: pxToEm(32),
        display: 'flex',
			  alignItems: 'center',
        '& .swatch': {
          borderRadius: pxToEm(16),
          width: pxToEm(32),
          height: pxToEm(32),
          marginRight: pxToEm(3),
          border: replacePXinStringWithEM('2px solid rgb(238, 242, 246)'),
          position: 'relative'
        }
      }
    },
    '& .collapsable.opened': {
      maxHeight: pxToRem(3000),
      overflow: 'visible !important',
      '& .innerWrap': {
        display: 'flex',
        [mediaQuery.customizeThinnest]: {
          display: 'block'
        }
      }
    },
    '& .collapsable': {
      '& .innerWrap': {
        display: 'flex',
        [mediaQuery.customizeThinnest]: {
          display: 'block'
        }
      }
    },
    '& .colorschemeconfig':{
      marginRight: pxToEm(8),
      maxWidth: pxToEm(480),
      [mediaQuery.customizeThinnest]: {
        marginRight: 0,
        marginBottom: pxToEm(8),
        maxWidth: 'none'
      },
      '& .sectioncard':{
        padding: replacePXinStringWithEM('32px 24px 96px 24px'),
        [mediaQuery.customizeThinnest]: {
          textAlign: 'center'
        },
        '& .sectiongroupdescription': {
          '& > h4': {
            marginTop: pxToRem(8)
          },
          '& > h2': {
            marginBottom: 0
          }
        }
      },
      '& .content': {
        '& .colorpickercolumn': {
          margin: replacePXinStringWithEM('16px 80px 0px 80px'),
          display: 'block',
          width: '100%',
          [mediaQuery.customizeThinnest]: {
            margin: 'auto',
            marginTop: pxToEm(16)
          },
          '& .colorpicker': {
            marginBottom: pxToEm(16),
            display: 'flex',
            flexDirection: 'column',
            flex: 1,
            marginBottom: pxToEm(16),
            '& .formelement': {
              [mediaQuery.customizeThinnest]: {
                maxWidth: pxToEm(175),
              },
            },
            '&:last-child': {
              marginBottom: 0
            }
          }
        }
      }
    },
    '& .previewratingsunit':{
      marginTop: 0,
      cursor: 'default',
      '& .sectioncard':{
        maxWidth: pxToEm(364),
        padding: 0,
        [mediaQuery.customizeThinnest]: {
          maxWidth: 'none',
          width: '100%'
        },
        '& .sectiongroup': {
          '&:not(:first-child)': {
            marginTop: 0,
            '& .sectiongroupdescription': {
              padding: replacePXinStringWithEM('34px 64px 0px 32px')
            }
          }
        },
        '& .sectiongroupdescription': {
          padding: replacePXinStringWithEM('39.5px 32px 0px 39px'),
          '& > h4': {
            marginTop: pxToRem(8)
          },
          '& > h2': {
            marginBottom: 0
          }
        }
      },
      '& .ratingsunit': {
        padding: replacePXinStringWithEM('37px 39.5px 37px 39.5px'),
        '& .ratingsunitheader': {
          textAlign: 'center',
          '& span': {
            lineHeight: pxToEm(20),
            fontSize: pxToEm(15),
            fontWeight: 'bold'
          },
        },
        '& .starset': {
          marginTop: pxToEm(20),
          display: 'flex',
          '& .star': {
            textAlign: 'center',
            display: 'block',
            height: pxToEm(72),
            width: pxToEm(49),
            marginRight: pxToEm(8),
            [mediaQuery.customizeThinnest]: {
              marginRight: 'auto'
            },
            '& .icon': {
              fontSize: pxToEm(40),
              marginBottom: pxToEm(3),
              '& i': {
                WebkitTextStroke: '1px white'
              },
              [mediaQuery.customizeThinnest]: {
                fontSize: pxToEm(30)
              }
            },
            '& span': {
              lineHeight: pxToEm(20),
              fontSize: pxToEm(14),
              fontWeight: 'normal'
            },
            '&:last-child': {
              marginRight: 0
            }
          }
        }
      },
      '& .divider': {
        margin: 0,
        display: 'block',
        width: '100%',
        height: pxToEm(1),
      },
      '& .ratingscounter': {
        margin: replacePXinStringWithEM('41px 24px 20px 27px'),
        '& .topbar': {
          display: 'flex',
          marginBottom: pxToEm(7),
          '& .ratingscore': {
            lineHeight: pxToEm(19),
            fontSize: pxToEm(16),
            fontWeight: '600',
            marginRight: pxToEm(6)
          },
          '& .stars': {
            fontSize: pxToEm(15),
            '& svg': {
              marginRight: pxToEm(3),
              height: '17px',
              width: '19px',
              '&:last-child': {
                marginRight: pxToEm(5)
              }
            } 
          },
          '& .ratingscount': {
            '& span': {
              fontSize: pxToEm(16),
              fontWeight: 'normal'
            }
          }
        },
        '& .ratingscounterbox': {
          borderRadius: pxToEm(5),
          display: 'block',
          paddingTop: pxToEm(16),
          '& .ratingrow': {
            margin: replacePXinStringWithEM('0px 12px 10px 20px'),
            display: 'flex',
            height: pxToEm(20),
            '&:last-child': {
              marginBottom: '15.5px'
            },
            '& span': {
              lineHeight: pxToEm(20),
              fontSize: pxToEm(16),
              fontWeight: 'normal'
            },
            '& .ratingbar': {
              margin: replacePXinStringWithEM('4px 15px 8px 17px'),
              borderRadius: pxToEm(4),
              height: pxToEm(8),
              width: '55%',
              '& .ratingpercent': {
                height: pxToEm(8),
                borderRadius: pxToEm(4),
              }
            }
          },
          '& .leaverating': {
            padding: replacePXinStringWithEM('14.5px 103.5px 13px 103.5px'),
            [mediaQuery.customizeThinnest]: {
              padding: replacePXinStringWithEM('14.5px 0px 13px 0px'),
            },
            lineHeight: pxToEm(20),
            fontSize: pxToEm(15),
            fontWeight: 'bold',
            textAlign: 'center'
          }
        }
      } 
    }
  }
});
